import defensiveCopy from "@/util/defensive-copy";
import {
  Template,
  TemplateSettings,
  TemplateStatus
} from "@/subapps/manage-templates/types";
import isEqual from "lodash/isEqual";

interface WithIdAndStatus {
  id: number;
  status?: TemplateStatus;
}

export function saveNewTemplate<T extends WithIdAndStatus>(
  newTemplate: T,
  templates: T[]
) {
  const templateIndex = templates.findIndex(t => t.id === newTemplate.id);

  const newTemplates = defensiveCopy(templates);

  if (templateIndex !== -1) {
    newTemplates[templateIndex] = defensiveCopy(newTemplate);
  } else {
    newTemplates.unshift(defensiveCopy(newTemplate));
  }

  return newTemplates;
}

export function deleteTemplate<T extends WithIdAndStatus>(
  idToDelete: number,
  templates: T[]
) {
  const templateIndex = templates.findIndex(
    t => "id" in t && t.id === idToDelete
  );

  const newTemplates = defensiveCopy(templates);

  if (templateIndex !== -1) {
    newTemplates.splice(templateIndex, 1);
  }

  return newTemplates;
}

export function changeTemplateStatus<T extends WithIdAndStatus>(
  idToDelete: number,
  templates: T[],
  status: TemplateStatus
) {
  const templateIndex = templates.findIndex(
    t => "id" in t && t.id === idToDelete
  );

  const newTemplates = defensiveCopy(templates);

  if (templateIndex !== -1) {
    newTemplates[templateIndex].status = status;
  }

  return newTemplates;
}

export function deleteAllTrash<T extends WithIdAndStatus>(templates: T[]) {
  return defensiveCopy(templates).filter(t => t.status !== "trash");
}

export function checkIfTemplateSettingsAlreadyExistsAndConfirmToContinue(
  templates: Template[],
  templateSettings: TemplateSettings,
  templateName: string
) {
  const templateSettingsAlreadyExists = templates.find(t =>
    isEqual(t.settings, templateSettings)
  );

  return templateSettingsAlreadyExists
    ? confirm(
        `You already have a ${templateName} with the same settings called "${templateSettingsAlreadyExists.title}". Continue anyway?`
      )
    : true;
}
